import { useContext } from "react";
import { BranchContext, BranchContextType } from "./BranchContext";

/**
 * Hook do używania Branch Context w komponentach
 *
 * @throws {Error} Jeśli hook jest używany poza BranchProvider
 * @returns {BranchContextType} Branch context value
 *
 * @example
 * const { currentBranch, switchBranch, availableBranches } = useBranchContext();
 */
export const useBranchContext = (): BranchContextType => {
  const context = useContext(BranchContext);

  if (context === undefined) {
    throw new Error("useBranchContext must be used within a BranchProvider");
  }

  return context;
};
